// DocumentIcon.jsx

import React from 'react';

/**
 * DocumentIcon
 *
 * @returns {ReactNode} The rendered component.
 */
const DocumentIcon = React.memo(({ width = 24, height = 24, ...rest }) => {

  // ----- RENDER ----- //

  return (
  <svg
    width={width}
    height={height}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    {...rest}
  >
    <path
      style={{
        opacity: 0.2,
      }}
      d="m 14.5,8.0000001 c -1.385,0 -2.5,1.115 -2.5,2.4999999 v 45 c 0,1.385 1.115,2.5 2.5,2.5 h 35 C 50.885,58 52,56.885 52,55.5 V 23 L 38.25,21.75 37,8.0000001 Z"
    />
    <path fill="#3e50b4" d="m14.5 7c-1.385 0-2.5 1.115-2.5 2.5v45c0 1.385 1.115 2.5 2.5 2.5h35c1.385 0 2.5-1.115 2.5-2.5v-32.5l-13.75-1.25-1.25-13.75z" />
    <path
      style={{
        opacity: 0.2,
      }}
      d="M 37,8.0000001 V 20.5 c 0,1.3808 1.1193,2.5 2.5,2.5 H 52 Z"
    />
    <path fill="#7482d0" d="m37 7v12.5c0 1.3808 1.1193 2.5 2.5 2.5h12.5l-15-15z" />
    <path
      style={{
        opacity: 0.2,
      }}
      d="m 21,30 v 3 h 22 v -3 z m 0,6 v 3 h 22 v -3 z m 0,6 v 3 h 22 v -3 z m 0,6 v 3 h 16 v -3 z"
    />
    <path fill="#fff" d="m21 29v3h22v-3h-22zm0 6v3h22v-3h-22zm0 6v3h22v-3h-22zm0 6v3h16v-3h-16z" />
    <path
      style={{
        fill: '#ffffff',
        opacity: 0.1,
      }}
      d="m 14.5,7.0000001 c -1.385,0 -2.5,1.115 -2.5,2.5 V 10.5 C 12,9.1150001 13.115,8.0000001 14.5,8.0000001 H 37 c 0,-1 0,0 0,-1 z"
    />
  </svg>
  );
});

// Dev Tools
DocumentIcon.displayName = 'DocumentIcon';

export default DocumentIcon;
